const ImageLoader = () => (
  <div className="absolute inset-0 z-40 flex items-center justify-center">
    <div
      className="animate-morph h-20 w-20"
      data-cy="product-main-slider-main-img-spinning"
    />
  </div>
)

export default ImageLoader
